import { HelpCenterIndex } from "../../../../src/components/help-center";
import { Footer } from "../../../../src/components/common/footer";
import * as React from 'react';
export default {
  HelpCenterIndex,
  Footer,
  React
};